import { Controller, MobileContextMenu } from '@tencent/workbench';
import { DeleteAttachmentFeature } from './delete-attachment-feature';
import { MOBILE_CONTEXTMENU_ITEMS, config } from './config';
import { isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';

@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class DeleteAttachmentController {
    constructor(private readonly feature: DeleteAttachmentFeature) {
    }

    @MobileContextMenu(config.name, 'onClick')
    public onClick() {
        this.feature.delete();
    }

    @MobileContextMenu(config.name, 'shouldHide')
    public shouldHide() {
        const model = this.feature.getSelectionService().selectedElements.getCurrentModel();
        return !isUiModelIsAttachment(model);
    }
}
